module.exports = __webpack_public_path__ + "static/media/realtalk_sd_dx6f27e99fe330b8dae3a1d9394deb44936.webp";